import { Chip, Stack, TextField } from "@mui/material";
import take from "lodash/take";
import type { FC } from "react";
import type { SelectedTag } from "./TagSelect";

interface Props {
  readonly label: string;
  readonly tags: SelectedTag[];
  /** Tags the user wants absent; rendered after `tags` as "nie <value>" chips. */
  readonly excludedTags?: SelectedTag[];
  readonly readonly?: boolean;
  readonly maxVisibleTags: number;
  readonly onOpen: () => void;
}

interface TagChip {
  readonly tag: SelectedTag;
  readonly excluded: boolean;
}

/** Read-only text field showing the selected tags as chips; clicking it calls `onOpen`. */
const TagSelectField: FC<Props> = ({ label, tags, excludedTags = [], readonly, maxVisibleTags, onOpen }) => {
  const chips: TagChip[] = [
    ...tags.map((tag) => ({ tag, excluded: false })),
    ...excludedTags.map((tag) => ({ tag, excluded: true })),
  ];
  return (
    <TextField
      label={label}
      fullWidth
      value={chips.length > maxVisibleTags ? "..." : ""}
      disabled={readonly}
      slotProps={{
        input: {
          startAdornment: (
            <Stack direction="row" spacing={1}>
              {take(chips, maxVisibleTags).map(({ tag, excluded }) => (
                <Chip
                  key={`${excluded ? "!" : ""}${tag.category}:${tag.value}`}
                  label={excluded ? `nie ${tag.value}` : tag.value}
                  color={excluded ? "error" : "default"}
                  size="small"
                  data-testid="tag-chip"
                />
              ))}
            </Stack>
          ),
        },
        inputLabel: { shrink: true },
      }}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onOpen();
      }}
    />
  );
};

export default TagSelectField;
